module.exports = __webpack_public_path__ + "img/mt5-icon3.c364664.png";